import {isElectron} from "react-device-detect";
import axios from "axios";
import {makeStrForGetReqFromObj} from "../helpers/functions";
import store from "../localStorage";
import configApp from "../config/config";
import {API_DEFAULT_CONFIG, API_ROOT} from "./api-config";

let logger;

try {
    logger = require('electron-log');
} catch (e) {
    console.log(e.message);
}

const NETWORK_ERROR = 'NETWORK_ERROR';

export default class apiHandling {
    props = {
        name: 'apiHandling',
    }

    static handleFailReq = (error) => {
        let fieldValidationErrors = {};
        if (error.response) {
            if (error.response.hasOwnProperty('data')) {
                for (let key in error.response.data) {
                    if (error.response.data.hasOwnProperty(key)) {
                        fieldValidationErrors[key] = [];
                        fieldValidationErrors[key].push(error.response.data[key]);
                        if (isElectron) {
                           // logger.error(error.response.data[key]);
                        }
                    }
                }
            }
        } else {
            if (isElectron) logger.error(error);

            fieldValidationErrors.error = [];
            fieldValidationErrors.error[0] = error.message;
        }

        fieldValidationErrors.typeError = NETWORK_ERROR;

        return fieldValidationErrors;
    }

    static req = (options) => {
        let handleFailReq = this.handleFailReq;

        return new Promise((resolve, reject) => {
            let _options = {...options};
            if (!_options.hasOwnProperty('action')) throw new NotHasOption('Required option action');
            if (!_options.hasOwnProperty('data')) _options.data = {};
            if (configApp.mode_response === 'json_local') {
                try {
                    const data = require(`./../data/response/public/${_options.action}.json`);
                    const response = {
                        data: data
                    }
                    resolve(response);
                } catch (e) {
                    let errors = this.handleFailReq(e);
                    reject(errors);
                }
            } else {
                let config = {
                    responseType: 'application/json',
                    ...API_DEFAULT_CONFIG
                };
                if (_options.hasOwnProperty('method') && _options.method === 'post') {
                    axios.post(`${API_ROOT}/public/${_options.action}`, _options.data, config)
                    .then(response => resolve(response))
                    .catch(e => {
                        let errors = handleFailReq(e);
                        reject(errors);
                    });
                } else {
                    const data = makeStrForGetReqFromObj(_options.data);
                    axios.get(`${API_ROOT}/public/${_options.action}${data}`, config)
                    .then(response => resolve(response))
                    .catch(e => {
                        let errors = handleFailReq(e);
                        reject(errors);
                    });
                }
            }
        });
    }

    /**
     * Выполняет запрос по ссылке, подходит для "чужих" серверов
     * @param link - http://hyperoff.ru
     * @param method - get|post
     * @param data - {}
     * @returns {Promise<unknown>}
     */
    static reqByLink = (link, method = 'get', data = {}) => {
        let handleFailReq = this.handleFailReq;

        return new Promise((resolve, reject) => {
            if (!link) throw new NotHasOption('Required option link');
            if (configApp.mode_response !== 'json_local') {
                let token = store.getState().userState.token;
                if (token) apiDefaultConfig.headers.Authorization = 'Token ' + token;
                let config = {
                    responseType: 'application/json',
                    ...API_DEFAULT_CONFIG
                };
                if (method === 'post') {
                    axios.post(link, data, config)
                    .then(response => resolve(response))
                    .catch(e => {
                        let errors = handleFailReq(e);
                        reject(errors);
                    });
                } else {
                    let str_data = makeStrForGetReqFromObj(data);
                    axios.get(link + str_data, config)
                    .then(response => resolve(response))
                    .catch(e => {
                        let errors = handleFailReq(e);
                        reject(errors);
                    });
                }
            }
        });
    }
}

/**
 * @param message
 * @constructor
 */
const NotHasOption = (message) => {
    this.message = message;
    this.name = 'Required option';
}